import { render } from "./BitacoraForm.vue?vue&type=template&id=68fdb6a7&scoped=true"
import script from "./BitacoraForm.vue?vue&type=script&lang=js"
export * from "./BitacoraForm.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=68fdb6a7&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=1&id=68fdb6a7&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fdb6a7"]])

export default __exports__